
"use client";

import { genLoginToken, checkLoginTokenStatus, autWithLoginToken } from 'bwax/query/userActions';
import React, { useEffect, useRef, useState } from 'react'
import QrCode from 'bwax-ui/auxiliary/QrCode';
import Modal from 'bwax-ui/components/Modal';
import Button from 'bwax-ui/components/Button';

import setTokenCookie from 'bwax-ui/setTokenCookieNext'

const INIT_COUNT = 90

export default function WechatLoginQrCode({ 
    size = 128, onCountDown = _ => { }, onSuccess, showCountDown, loadingElement = null, tip ,
    mobileHost,
}) {

    const [loginToken, setLoginToken] = useState();
    const [showRefreshModal, setShowRefreshModal] = useState(false);
    const [refreshCountDown, setRefreshCountDown] = useState(5);

    async function refreshLoginToken() {
        try {
            const loginToken = await genLoginToken();
            setLoginToken(loginToken);
        } catch (error) {
            console.warn("genLoginToken error:", error?.message || error);
            setShowRefreshModal(true);
        }
    }

    const [countDown, setCountDown ] = useState(INIT_COUNT);
    const countDownRef = useRef(countDown);
    countDownRef.current = countDown;

    useEffect(() => {
        refreshLoginToken();
        // 倒计时
        const timer = setInterval(() => {
            const count = countDownRef.current;
            onCountDown(count - 1)
            if(count > 1) {
                setCountDown(prev => prev - 1)            
            } else {
                setCountDown(INIT_COUNT);
                refreshLoginToken();
            }
        }, 1000)
        return _ => { clearInterval(timer)}
    }, []);

    // 刷新倒计时
    useEffect(() => {
        if (showRefreshModal) {
            const timer = setInterval(() => {
                setRefreshCountDown(prev => {
                    if (prev <= 1) {
                        window.location.reload();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [showRefreshModal]);


    async function checkLoginStatus(token) {
        try {
            const status = await checkLoginTokenStatus(token);

            if(status == "Confirmed") {
                // login with it
                const sessionToken = await autWithLoginToken(token);
                if(sessionToken) {
                    // 登陆成功:
                    await setTokenCookie(sessionToken);
                    onSuccess()
                }
            }
        } catch (error) {
            console.warn("checkLoginStatus error:", error?.message || error);
            setShowRefreshModal(true);
        }
    }


    useEffect(() => {
        if(loginToken && loginToken.token && !showRefreshModal) {
            const timer = setInterval(() => {
                checkLoginStatus(loginToken.token)
            }, 1500);
            return () => {
                clearInterval(timer)
            }
        } 
    }, [loginToken, showRefreshModal]);

    const getQrCodeURL = (loginToken) => {
        const { qrCodeUrl, token } = loginToken;
        // 这个 url prefix 可以从服务器读，因为要区分 sandbox
        return qrCodeUrl || `https://${mobileHost}/` + "ext/auth/confirm-token/" + token;
    }

    function renderCountDown() {
        if(!showCountDown) {
            return null
        }
        return (
            <div className="text-[var(--gray-11)] font-size-13">
                请用手机微信扫码登录 { countDown }s
            </div>
        )
    }

    function renderRefreshModal() {
        return (
            <Modal 
                isOpen={showRefreshModal} 
                isDismissable={false}
                closeButton={false}
                className="max-w-sm"
            >
                <div className="flex flex-col gap-4 p-6 pb-8">
                    <div className="font-size-16 font-medium">版本已更新</div>
                    <div className="text-[var(--gray-11)]">
                        服务器版本有更新，请刷新页面
                    </div>
                    <div className="flex justify-end">
                        <Button 
                            color="main" 
                            appearance="primary"
                            onPress={() => window.location.reload()}
                        >
                            刷新页面 ({refreshCountDown}s)
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }

    return (
        <div className="flex flex-col items-center gap-1.5">
            {renderRefreshModal()}
            { loginToken && loginToken.token ? (
                <>
                    <QrCode info={getQrCodeURL(loginToken)} size={size} />
                    { renderCountDown() }
                </>
            ) : loadingElement}
        </div>  
    )

}